export default __webpack_public_path__ + "static/media/icon-blog-link.ee9860aaab8380e596ba43367eb3be48.svg";